import { CarDetailsErrorCauses } from '../../_tools/errors/car-details';
import { CarListErrorCauses } from '../../_tools/errors/car-list';
import { ConfigErrorCauses } from '../../_tools/errors/config';
import { ErrorAction, Errors } from '../../_tools/types/function-output-type';
import { type TranslationsErrors } from './translations';

const frFR: TranslationsErrors = {
    actions: {
        [ErrorAction.NONE]: '',
        [ErrorAction.EXIT]: "Cacher l'erreur",
        [ErrorAction.HOME]: "Retour à la page d'accueil",
        [ErrorAction.RELOAD]: 'Recharger la page',
    },
    default: {
        heading: 'Désolé, une erreur est survenue!',
        description: 'Veuillez réessayer plus tard.',
    },
    [Errors.API]: {
        webcalc: {
            heading: 'WebCALC-Erreur',
            description: "Malheureusement, une erreur s'est produite lors de la demande des données de calcul. Veuillez réessayer plus tard!",
        },
    },
    [Errors.CAR_DETAILS]: {
        [CarDetailsErrorCauses.ERROR]: {
            heading: 'Erreur lors de la récupération des données du véhicule',
            description: '',
        },
        [CarDetailsErrorCauses.NOT_FOUND]: {
            heading: 'Véhicule non trouvé',
            description: '',
        },
    },
    [Errors.CAR_LIST]: {
        [CarDetailsErrorCauses.ERROR]: {
            heading: 'Erreur lors de la récupération de la liste des véhicules',
            description: '',
        },
        [CarListErrorCauses.NO_RESULTS]: {
            heading: 'Véhicules non trouvé',
            description: '',
        },
    },
    [Errors.CONFIG]: {
        [ConfigErrorCauses.DISABLED]: {
            heading: 'AHD Fleet désactivé',
            description: "Vous êtes l'exploitant? Dans ce cas, veuillez vous adresser à l'administrateur.",
        },
        [ConfigErrorCauses.HOST_NOT_FOUND]: {
            heading: "L'hôte n'a pas été trouvé",
            description: 'Veuillez contacter le support client.',
        },
        [ConfigErrorCauses.MISSING_IDGROUP]: {
            heading: 'Le champ "idGroup" est absent de la configuration',
            description: 'Veuillez contacter le support client.',
        },
        [ConfigErrorCauses.MISSING_LEADSYSTEM]: {
            heading: 'Le champ "contactLeadSystem" est absent de la configuration',
            description: 'Veuillez contacter le support client.',
        },
        [ConfigErrorCauses.MISSING_LINKDISCLAIMER]: {
            heading: 'Le champ "linkDisclaimer" est absent de la configuration',
            description: 'Veuillez contacter le support client.',
        },
        [ConfigErrorCauses.MISSING_MAIL]: {
            heading: "L'adresse mail de contact n'est pas configurée.",
            description: 'Veuillez contacter le support client.',
        },
    },
    [Errors.MODULE_DISABLED]: {
        heading: 'Désolé, mais le module "{0}" n\'est pas disponible pour le moment!',
        description: "Vous êtes l'exploitant? Dans ce cas, veuillez vous adresser à l'administrateur.",
    },
};

export default frFR;
